import type { MutationTree } from 'vuex'
import { SET_PARTNER, SET_ROLE, SET_USER, SET_AUTHENTICATED, SET_CODE } from './types'

export const mutations: MutationTree<AuthState> = {
  [SET_PARTNER](state: AuthState, partner: number[]) {
    state.partner = partner
  },
  [SET_ROLE](state: AuthState, role: number) {
    state.role = role
  },
  [SET_USER](state: AuthState, user: UserModel) {
    state.user = user
  },
  [SET_AUTHENTICATED](state: AuthState, b: boolean) {
    state.isAuthenticated = b
  },
  [SET_CODE](state: AuthState, code: string) {
    state.code = code
  },
}
